import PropTypes from 'prop-types';

function IconPlus({ margin = '15px', fill = '#CFD8E2' }) {
  const style = {
    margin,
  };
  return (
    <svg
      style={style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.21209 7.23203V1.60003C7.21209 1.17588 7.55594 0.832031 7.98009 0.832031C8.40425 0.832031 8.74809 1.17588 8.74809 1.60003V7.23203H14.3602C14.7843 7.23203 15.1282 7.57588 15.1282 8.00003C15.1282 8.42419 14.7843 8.76803 14.3602 8.76803H8.74809V14.4C8.74809 14.8242 8.40425 15.168 7.98009 15.168C7.55594 15.168 7.21209 14.8242 7.21209 14.4V8.76803H1.60003C1.17588 8.76803 0.832031 8.42419 0.832031 8.00003C0.832031 7.57588 1.17588 7.23203 1.60003 7.23203H7.21209Z"
        fill={fill}
      />
    </svg>
  );
}

IconPlus.propTypes = {
  fill: PropTypes.string,
  margin: PropTypes.string,
};

export default IconPlus;
